import {HubApi} from './hub-api';
import {HubInstances} from '../hub-instances';
import {BaseApiWrapper} from '../base-api-wrapper';

export class HubApiBuilder extends BaseApiWrapper {
    private triumphUrl: string;
    private tbUrl: string;

    public constructor(triumphUrl: string, tbUrl: string) {
        super();
        this.triumphUrl = triumphUrl;
        this.tbUrl = tbUrl;
    }

    public getForGame(game: HubInstances): HubApi {
        let url: string;

        switch (game) {
            case HubInstances.TRIUMPH:
                url = this.triumphUrl;
                break;
            case HubInstances.TOTALBATTLE:
                url = this.tbUrl;
                break;
            default:
                throw new Error('Unknown game');
        }

        const hubApi = new HubApi(url);

        if (this.loggingAdapter) {
            hubApi.setLoggingAdapter(this.loggingAdapter);
        }

        if (this.metricsAdapter) {
            hubApi.setMetricsAdapter(this.metricsAdapter);
        }

        return hubApi;
    }
}
